import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router";
import { Button, Modal } from "react-bootstrap";

import AddLabelPage from "./AddLabelPage";
import EditLabelPage from "./EditLabelPage";
import DataTable from "../../../../controls/table/DataTable";
import AddIcon from "../../../../../assets/img/add.png";
import EditIcon from "../../../../../assets/img/Edit.png";
import DeleteIcon from "../../../../../assets/img/Delete.png";
import EmptyPage from "../../../../pages/EmptyPage";
import ContextComponent from "../../../../AppContext";

import Utils from "../../../../Utils";

function Labels() {
  const { siteid } = useParams();

  let [currSiteId, setCurrSiteId] = useState(siteid);
  let [siteName, setSiteName] = useState("");
  let [showDeleteModal, setShowDeleteModal] = useState(false);
  let [selectedItemCount, setSelectedItemCount] = useState(0);

  const DISABLED_ICON = Utils.APP_CLASS_NAMES.disableStyle;
  let [editIconClass, setEditIconClass] = useState(DISABLED_ICON);

  let [tableSelectedItems, setTableSelectedItems] = useState([]);
  let [labelIdForEdit, setLabelIdForEdit] = useState("");
  let [allLabels, setAllLabels] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    if (tableSelectedItems.length === 1) {
      setEditIconClass("");
      setLabelIdForEdit(tableSelectedItems[0]);
    } else {
      setEditIconClass(DISABLED_ICON);
      setLabelIdForEdit("");
    }
  }, [tableSelectedItems]);

  let [editModalCanOpen, setEditModalCanOpen] = useState(false);
  let [editableLabel, setEditableLabel] = useState({});
  let [editableLabelIndex, setEditableLabelIndex] = useState(-1);

  const openEditModal = (e) => {
    e.preventDefault();
    setEditModalCanOpen(true);
    let targetLabel = {};
    allLabels.forEach((label, index) => {
      if (label.id === labelIdForEdit) {
        targetLabel = label;
        setEditableLabelIndex(index);
      }
    });
    //console.log(targetUser);
    !Utils.isObjectEmpty(targetLabel) && setEditableLabel(targetLabel);
  };

  let { setCanRedirectToLogin, setLoadingState, userData, setAlert } =
    useContext(ContextComponent);

  let [tableColumns, setTableColumns] = useState([
    "id",
    "select",
    "labelcode",
    "labelType",
    "labeltext",
    "description",
  ]);

  let [tableColumnSchema, setTableColumnSchema] = useState({
    id: {
      type: "hidden",
      title: "id",
    },
    select: {
      type: "checkbox",
      title: "-",
    },
    labelcode: {
      type: "text",
      search: true,
      sort: true,
      title: "Label Code",
    },
    labelType: {
      type: "text",
      search: true,
      sort: true,
      title: "Label Type",
    },
    labeltext: {
      type: "text",
      search: true,
      sort: true,
      title: "Label Text",
    },
    description: {
      type: "text",
      search: true,
      sort: true,
      title: "Description",
    },
  });

  let [tableData, setTableData] = useState([]);
  let [canRender, setCanRender] = useState(false);
  let [renderDataTable, setRenderDataTable] = useState(false);
  let [renderEmptyPage, setRenderEmptyPage] = useState(false);
  let [updateTable, setUpdateTable] = useState(false);

  const updateTableData = (data) => {
    setAllLabels(data);
    let labelInfo = data;
    let labelsArray = [];
    if (!Utils.isObjectEmpty(labelInfo)) {
      labelsArray = labelInfo.map((label, index) => {
        let labelTableObj = [];
        let labelTableData = [];
        tableColumns.forEach((col) => {
          if (col === "select") {
            labelTableData.push(false);
          } else {
            labelTableData.push(labelInfo[index][col]);
          }
        });
        labelTableObj = labelTableData;
        return labelTableObj;
      });
      let name = data[0]?.site ?? '';
      name.length > 0 && setSiteName("(" + name + ")");
      setTableData(labelsArray);
      setCanRender(true);
    }
  };


  const success = (res) => {
    setLoadingState({
      applyMask: false,
    });
    updateTableData(res.data);

    setRenderDataTable(res.data.length !== 0);
    setRenderEmptyPage(res.data.length === 0);
  };

  const fail = (err) => {
    setLoadingState({
      applyMask: false,
    });
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const loadFreshLabels = (currSiteId) => {
    Utils.getAllLabelsBySitedId({ siteId: currSiteId }).then(success, fail);
  };

  useEffect(() => {
    setLoadingState({
      applyMask: true,
      text: "Loading labels",
    });
    loadFreshLabels(currSiteId);
  }, []);

  useEffect(() => {
    if (tableData.length) {
      // console.log("table has data now");
    }
  }, [tableData]);

  const handleShow = async (e) => {
    if (tableSelectedItems?.length > 0) {
      await setSelectedItemCount(tableSelectedItems?.length);
      setShowDeleteModal(true);
    }
  };

  const handleClose = async (e) => {
    await setSelectedItemCount(tableSelectedItems?.length);
    setShowDeleteModal(false);
  };

  const deleteSuccess = (res) => {
    setAlert({
      show: true,
      message: "Label(s) deleted successfully",
    });
    setTableSelectedItems([]);
    setUpdateTable(!updateTable);
  };

  const deleteFail = (err) => {
    err?.message?.length && console.log(err);
    if (err?.redirect) {
      setCanRedirectToLogin(true);
    }
  };

  const handleDelete = async (e) => {
    setShowDeleteModal(false);
    // setLoadingState({
    //   applyMask: true,
    //   text: "Deleting selected " + tableSelectedItems.length + " items",
    // });
    let tempTableData = tableData.filter((d) => {
      return tableSelectedItems.indexOf(d[0]) === -1;
    });
    setTableData(tempTableData);
    Utils.deleteLabels(tableSelectedItems).then(deleteSuccess, deleteFail);
  };

  let [addModalCanOpen, setAddModalCanOpen] = useState(false);

  const openAddModal = (e) => {
    e.preventDefault();
    setAddModalCanOpen(true);
  };

  const closeAddModal = (e) => {
    setAddModalCanOpen(false);
  };


  return (
    <div className="indi-body-cards-wrapper d-flex w-100">
      <div className="indi-add-card-title">
        <span>Labels <span className="indi-site-name-in-header">{siteName}</span></span>
        <div className="d-none1 w-50 indi-body-actions">
          <div
            className="indi-body-action"
            role="button"
            onClick={openAddModal}
          >
            <img className="indi-w-20" src={AddIcon} alt="Edit-icon"></img>
            Add
          </div>
          <div
            className={`indi-body-action ${editIconClass}`}
            role="button"
            onClick={openEditModal}
          >
            <img className="indi-w-20" src={EditIcon} alt="edit-icon"></img>
            Edit
          </div>

          <div className="indi-body-action" role="button" onClick={handleShow}>
            <img className="indi-w-20" src={DeleteIcon} alt="Delete-icon"></img>
            Delete
          </div>
        </div>
      </div>
      {canRender && (
        <>
          {renderDataTable && (
            <DataTable
              minRows={0}
              tableProps={{
                tableColumns,
                tableColumnSchema,
                tableData,
                tableSelectedItems,
                setTableSelectedItems,
              }}
            />
          )}
          {!renderDataTable && (
            <EmptyPage
              props={{
                emptyMessage: "No Fields are available",
              }}
            />
          )}
        </>
      )}

      <Modal centered show={showDeleteModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete confirmation?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete select {selectedItemCount} item(s)?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            No
          </Button>
          <Button variant="primary" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      {addModalCanOpen && (
        <AddLabelPage
          props={{
            addModalCanOpen,
            setAddModalCanOpen,
            tableData,
            setTableData,
            loadFreshLabels,
          }}
        />
      )}

      {editModalCanOpen && (
        <EditLabelPage
          props={{
            editModalCanOpen,
            setEditModalCanOpen,
            tableData,
            setTableData,
            editableLabel,
            editableLabelIndex,
            allLabels,
            setAllLabels,
            loadFreshLabels,
          }}
        />
      )}
    </div>
  );
}

export default Labels;
